module.exports = __webpack_public_path__ + "static/media/photo110.205729e0.jpg";